<template>
  <div v-if="isAd == 'Y' && (link_url != '' && link_url != undefined)" class="ad-block" @click="openLink(link_url);">
    <ion-grid>
      <ion-row class="ion-justify-content-start">
        <ion-col class="ion-no-padding">
          <div style="color:rgba(140,140,140,1.0); text-transform:uppercase; font-size:0.8em; margin: 5px;">{{
            getHostName(link_url) }}</div>
          <div style="margin: 5px"><strong>{{ link_text }}</strong></div>
        </ion-col>
        <ion-col size="sm" class="ion-no-padding">
          <ion-button>{{ $t("buttons.buynow") }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <ion-grid
    v-show="link_url != '' && link_url != null && type != 3 && isAd == '' && (link_url.search('.mp3') == -1 && link_url.search('.m4a') == -1)"
    @click="openLink(link_url)" class="ion-no-padding url-block">
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-no-padding" size="3" v-show="link_image != '' && link_image != null">
        <img @error="imgUrlAlt" class="cover" :src="link_image">
      </ion-col>
      <ion-col>
        <div class="link">{{ getHostName(link_url) }}</div>
        <div class="link_text" v-show="link_text != ''">{{ link_text }}</div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="ion-no-padding">
    <ion-row class="ion-align-items-center">
      <ion-col class="ion-no-padding">
        <span v-if="numberViews > 0" style="height:100%;" class="story-views"> {{ numberViews }} {{ $t("buttons.views") }}
        </span>
        <span v-else style="height:100%;" class="story-views">&nbsp;</span>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-button v-if="(totalpiks + totalvids) > 1 && this.$route.name != 'story' && this.$route.name != 'storyview'"
          size="small" color="clear" style="float:right; color:rgba(var(--dashboard-contrast-color-rgb), 1.0);"
          class="action-button" @click="openStoryPostsModal()">
          <ion-icon style="padding-right:5px;" slot="start" :icon="albumsOutline"></ion-icon>
          ({{ getImageIndex(pik_id) }}/{{ totalvids + totalpiks }})
        </ion-button>
        <span style="float:right; margin-right:15px;" class="story-views"
          v-if="(totalpiks + totalvids) > 1 && (this.$route.name == 'story' || this.$route.name == 'storyview')"> ({{
            getImageIndex(pik_id) }}/{{ totalvids + totalpiks }})</span>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid v-if="checkPremium()" style="padding-left:10px;" class="ion-no-padding">
    <ion-row class="ion-justify-content-start">
      <ion-col>
        <ion-button v-on:click="likeItem()" v-on:mousedown="likeStart($event, story, index)" v-on:mouseup="likeStop()"
          @touchstart.passive="likeStart($event, story, index)" @touchend="likeStop()" color="none" class="action-button">
          <img v-show="displayCustomIcon(likeittype) != ''" slot="start"
            :style="'width: 20px; height: auto; margin-right:5px;'" :src="displayCustomIcon(likeittype)">
          <ion-icon v-show="displayCustomIcon(likeittype) == ''" slot="start" :style="displayStyle(likeittype)"
            :icon="displayIcon(likeittype)"></ion-icon><span v-show="likes > 0" class="action-button-text">{{
              likes
            }}</span>
        </ion-button>
        <ion-button style="text-align: center" @click="openCommentModal(totalcomments)" color="none" class="action-button"
          v-if="this.$store.state.helpers.commentToggle == '' && checkGroupStatus()">
          <ion-icon slot="start" style="font-size: 16px; color: rgba(140, 140, 140, 1)"
            :icon="chatbubbleOutline"></ion-icon>
          <span v-show="totalcomments > 0" class="action-button-text">{{
            totalcomments
          }}</span>
        </ion-button>
        <ion-button style="text-align: center" @click="favoriteStory()" color="none" class="action-button">
          <ion-icon slot="start" :style="showFollowIcon(story)" :icon="bookmarkOutline"></ion-icon>
          <span v-show="numberFav > 0" class="action-button-text">{{
            numberFav
          }}</span>
        </ion-button>
        <ion-button v-if="story.isPremium != 'yes'" @click="openSharePopover($event, story, index)" color="none"
          class="action-button">
          <ion-icon slot="start" style="font-size: 18px; color: rgba(140, 140, 140, 1)" :icon="shareOutline"></ion-icon>

          <span v-show="numberRepost > 0" class="action-button-text">{{
            numberRepost
          }}</span>
        </ion-button>
        <ion-button @click="toggleLiveChat" v-if="getCurrentImage().live_video!='' && getCurrentImage().live_video!=undefined" color="none"
          class="action-button">
          <ion-icon slot="start" style="font-size: 18px; color: rgba(140, 140, 140, 1)" :icon="chatbubbleEllipsesOutline"></ion-icon>
            <span class="action-button-text">{{ showLiveChat ? 'Hide' : 'Chat' }}</span>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row v-if="showStartBroadcastButton">
      <ion-col>
      <ion-button  @click="startScheduledBroadcast" expand="full" color="primary">
          <ion-icon slot="start" style="font-size: 18px; color: #fff" :icon="videocam"></ion-icon>
          Start Broadcast
        </ion-button>
        </ion-col>
    </ion-row>
  </ion-grid>
  <LiveCommentContainer v-if="showLiveChat && (this.$route.name == 'story' || this.$route.name == 'storyview')" :videoId="Number(getCurrentImage().id)" :isLive="getCurrentImage().type==4" />
  <CommentsContainer v-if="commentBox() && getCurrentImage().type!=4" :image="getCurrentImage()" :total="totalcomments" />
  <!-- <div class="story-footer-border"></div> -->
</template>
<script>
import {
  IonIcon,
  IonCol,
  IonGrid,
  IonRow,
  IonButton,
  popoverController,
  modalController,
  loadingController,
  toastController,
  alertController,
  isPlatform
} from "@ionic/vue";
import { heartOutline, videocam, shareOutline, bookmarkOutline, chatbubbleOutline, albumsOutline, chatbubbleEllipsesOutline } from "ionicons/icons";
import { defineComponent, defineAsyncComponent } from "vue";
import { Share } from '@capacitor/share';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const LikesModal = defineAsyncComponent(() =>
  import("@/components/LikesModal.vue")
);

const CommentsModal = defineAsyncComponent(() =>
  import("@/components/CommentsModal.vue")
);

const ShareCommentModal = defineAsyncComponent(() =>
  import("@/components/posts/ShareComment.vue")
);

const ShareMyStoryModal = defineAsyncComponent(() =>
  import("@/components/ChooseStoryModal.vue")
);

const ShareOtherModal = defineAsyncComponent(() =>
  import("@/components/ShareOtherModal.vue")
);

const StoryPostsModal = defineAsyncComponent(() =>
  import("@/components/StoryPostsModal.vue")
);

const Popover = defineAsyncComponent(() =>
  import("@/components/Popover.vue")
);

const LikePopover = defineAsyncComponent(() =>
  import("@/components/LikePopover.vue")
);

const CommentsContainer = defineAsyncComponent(() =>
  import('@/components/CommentsContainer.vue'))

import LiveCommentContainer from '@/components/LiveCommentContainer.vue';

import SignupModal from '@/components/SignupModal.vue'
import getEnv from "@/utils/env";
import { Browser } from '@capacitor/browser';

export default defineComponent({
  name: "PostFooter",
  emits: ['update:likes', 'update:likeittype', 'update:likeit', 'update:numberRepost', 'update:numberFav', 'update:watching', 'update:totalcomments'],
  props: {
    story: { Object, default: null },
    totalpiks: { Number, default: 0 },
    totalvids: { Number, default: 0 },
    likeittype: { String, default: '' },
    likeit: { Number, default: 0 },
    likes: { Number, default: 0 },
    totalcomments: { Number, default: 0 },
    numberFav: { Number, default: 0 },
    watching: { Number, default: 0 },
    numberRepost: { Number, default: 0 },
    numberViews: { Number, default: 0 },
    current_index: { Number, default: 0 },
    link_url: { String, default: '' },
    link_image: { String, default: '' },
    link_text: { String, default: '' },
    isAd: { String, default: '' },
    type: { Number, default: 0 },
    pik_id: { String, default: '' },
    slider: { Number, default: 0 }
  },
  setup() {
    return { bookmarkOutline, chatbubbleOutline, shareOutline, heartOutline, videocam, albumsOutline, chatbubbleEllipsesOutline };
  },
  data() {
    return {
      openedAutoComment: 0,
      showLiveChat: false,
    }
  },
  computed: {
    showStartBroadcastButton() {
      // Only show if user is the broadcaster, post is a scheduled premiere, and time is near
      const userId = this.$store.state.profile?.id;
      const isBroadcaster = userId && String(userId) === String(this.story.piklist_user_id);
      const currentImage = this.getCurrentImage();

      // Assume scheduled_time is a UTC-5 string on the image or story
      const scheduledTime = currentImage?.premiere_date;
      const isLive = currentImage?.type == 4;
      if (!isBroadcaster || !scheduledTime || !isLive) return false;
      // Use dayjs to parse scheduledTime as UTC-5 and compare to now
      const scheduled = dayjs.tz(scheduledTime, 'YYYY-MM-DDTHH:mm', 'Etc/GMT+5');
      const now = dayjs();
      const diffMinutes = scheduled.diff(now, 'minute');
      // Show if within 30 minutes before or 15 minutes after scheduled time
      return diffMinutes <= 30 && diffMinutes > -15;
    }
  },
  components: {
    IonIcon,
    IonCol,
    IonGrid,
    IonRow,
    IonButton,
    CommentsContainer,
    LiveCommentContainer
  },
  /* async mounted() {
    if (this.$route.query.comment == 1 && this.openedAutoComment == 0 && this.pik_id == this.$route.params.imageid) {
      let sliderImage;
      for (var i = 0; i < this.story.allimages.length; i++) {
        if (this.story.allimages[i].id == this.pik_id) {
          sliderImage = this.story.allimages[i];
        }
      }
      this.openedAutoComment = sliderImage.id;
      //console.log(this.openedAutoComment, 'after auto comment');
      await this.autoCommentModal(sliderImage, this.totalcomments);
    }
  }, */
  methods: {
    async openLikeModal() {
      const modal = await modalController.create({
        component: LikesModal,
        cssClass: "modal-custom-class",
        componentProps: {
          title: this.$t("modalhead.likes"),
          imageId: this.pik_id,
        },
      });
      return await modal.present();
    },
    getCurrentImage(){
      let sliderImage;
      if (this.$store.state.helpers.commentToggle == "") {
        if (this.$store.state.auth.token != "") {
          for (var i = 0; i < this.story.allimages.length; i++) {
            if (this.story.allimages[i].id == this.pik_id) {
              sliderImage = this.story.allimages[i];
            }
          }
        }
      }
      return sliderImage;
    },
    toggleLiveChat() {
       if(this.$route.name != 'story' && this.$route.name != 'storyview'){
        this.$router.push({name: 'story', params: { imageid: this.pik_id, comment: 0 }});
       }else{
        this.showLiveChat = !this.showLiveChat;
       }
    },
    async startScheduledBroadcast() {
      this.$router.push({
        name: 'livebroadcast',
        query: { premiereId: this.pik_id }
      });
    },
    async openCommentModal(totalComments) {
      if (this.$store.state.helpers.commentToggle == "") {
        if (this.$store.state.auth.token != "") {
          let sliderImage;
          for (var i = 0; i < this.story.allimages.length; i++) {
            if (this.story.allimages[i].id == this.pik_id) {
              sliderImage = this.story.allimages[i];
            }
          }
          this.$store.commit('comments/setComments', [null, sliderImage.id]);
          const modal = await modalController.create({
            component: CommentsModal,
            /* cssClass: 'modal-custom-class', */
            componentProps: {
              title: this.$t("modalhead.comments"),
              image: sliderImage,
              total: totalComments,
            },
          });
          modal.onDidDismiss().then(() => {
            //console.log('closed comment box');
            this.$emit('update:totalcomments', this.$store.state.comments.addComment + this.totalcomments);
            //this.displayTotalComments = this.$store.state.comments.addComment + this.displayTotalComments;
            this.$store.commit('comments/setAddComment', 0);
            this.completedPost();
          });
          return await modal.present();
        } else {
          this.presentLoginAlertConfirm();
        }
      }
    },
    async autoCommentModal(sliderImage, totalComments) {
      if (this.$store.state.helpers.commentToggle == "") {
        if (this.$store.state.auth.token != "") {
          this.$store.commit('comments/setComments', [null, sliderImage.id]);
          await this.$store.dispatch("comments/show", {
            imageid: sliderImage.id,
            currentPage: 0
          });
          this.openedAutoComment = sliderImage.id;
          const modal = await modalController.create({
            component: CommentsModal,
            /* cssClass: 'modal-custom-class', */
            componentProps: {
              title: this.$t("modalhead.comments"),
              image: sliderImage,
              total: totalComments,
            },
          });
          modal.onDidDismiss().then(() => {
            this.$emit('update:totalcomments', this.$store.state.comments.addComment + this.totalcomments);
            //this.displayTotalComments = this.$store.state.comments.addComment + this.displayTotalComments;
            this.$store.commit('comments/setAddComment', 0);
            this.completedPost();
          });
          return await modal.present();

        } else {
          this.presentLoginAlertConfirm();
        }
      }
    },
    async favoriteStory() {
      if (this.$store.state.auth.token != "") {
        let response = await this.$store.dispatch("helpers/favoriteStory", {
          id: this.story.piklist_id,
        });
        if (response) {
          if (response["error"] != null) {
            console.log("error favorite story");
          } else {
            // update the story
            if (response.data["id"] != undefined) {
              this.$emit('update:numberFav', this.numberFav + 1);
              this.$emit('update:watching', 1);
            } else {
              this.$emit('update:numberFav', this.numberFav - 1);
              this.$emit('update:watching', 0);
            }
            this.completedPost();

          }
        } else {
          console.log("unknown error");
        }
      } else {
        this.presentLoginAlertConfirm();
      }
    },
    showFollowIcon() {
      var styles = "font-size: 18px; color:rgba(140,140,140,1.0);";
      if (this.watching == 1) {
        styles =
          "font-size: 18px; color: rgba(var(--ion-color-primary-rgb), 1.0);";
      }

      return styles;
    },
    async openSharePopover(ev) {
      if (this.$store.state.auth.token != "") {
        //console.log(story);

        var type = "share-post";
        const popover = await popoverController.create({
          component: Popover,
          cssClass: "my-custom-class",
          event: ev,
          translucent: true,
          componentProps: {
            name: this.$t("modalhead.share"),
            type: type,
            data: this.story,
          },
        });
        await popover.present();
        const { role } = await popover.onDidDismiss();


        let sliderImage;
        for (var i = 0; i < this.story.allimages.length; i++) {
          if (this.story.allimages[i].id == this.pik_id) {
            sliderImage = this.story.allimages[i];
          }
        }
        if (sliderImage.originator_id == undefined) {
          sliderImage.originator_id = this.story.piklist_user_id;
        }

        if (role == "share") {
          await this.presentLoading();
          let response = await this.$store.dispatch("post/createRepostStory", {
            name: "",
            post: sliderImage,
          });
          if (response["error"] != undefined) {
            this.loadingIndicator.dismiss();
            console.log("Error: " + response["error"]);
          } else {
            this.$emit('update:numberRepost', this.numberRepost + 1);
            this.completedPost();
            this.presentToast('bottom', 'Post Shared!');
            this.loadingIndicator.dismiss();
          }
        } else if (role == "share-comment") {
          this.openShareCommentModal(sliderImage);
        } else if (role == "share-my-story") {
          this.openShareMyStoryModal(sliderImage);
        } else if (role == "share-other-places") {
          let canShare = await Share.canShare();
          if (canShare.value) {
            await this.nativeShare(sliderImage);
          } else {
            this.openShareOtherModal(sliderImage);
          }
        }
      } else {
        this.presentLoginAlertConfirm();
      }
      //console.log('onDidDismiss resolved with role', role);
    },
    async nativeShare(image) {
      if (this.story != null && image != null) {
        let postLink = "";
        let response = await this.$store.dispatch("helpers/shareLink", {
          story_id: this.story.piklist_id,
          id: image.id
        });
        if (response['error'] != undefined) {
          console.log('Error: ' + response['error']);
        } else {
          if (isPlatform('hybrid') || isPlatform('electron')) {
            postLink = 'https://' + getEnv('SHARE_HOSTNAME') + response.data.url;
          } else {
            postLink = 'https://' + window.location.hostname + response.data.url;
          }
        }
        let title = this.story.piklist_name;
        if(this.story.piklist_name!=''){
          title = "Share Post";
        }
        await Share.share({
          title: title,
          text: '',
          url: postLink,
          dialogTitle: 'Share Post',
        });
      } /* else {
        if (isPlatform('hybrid') || isPlatform('electron')) {
          postLink = 'https://' + getEnv('SHARE_HOSTNAME') + '/u/' + this.username;
        } else {
          postLink = 'https://' + window.location.hostname + '/u/' + this.username;
        }
      }*/
    },
    async openShareOtherModal(sliderImage) {
      //console.log(story);
      // NOTE: use the pik_id and get the full image object
      const modal = await modalController.create({
        component: ShareOtherModal,
        cssClass: "shareother-custom-class",
        componentProps: {
          title: this.$t("modalhead.shareother"),
          image: sliderImage,
          story: this.story,
        },
      });
      return await modal.present();
    },
    async openShareCommentModal(sliderImage) {
      // calculate post id here
      const modal = await modalController.create({
        component: ShareCommentModal,
        cssClass: "editpost-custom-class",
        componentProps: {
          title: this.$t("modalhead.sharecomment"),
          image: sliderImage,
        },
      });

      modal.onDidDismiss().then(() => {
        this.completedPost();
        this.presentToast('bottom', 'Post Shared!');
        this.$emit('update:numberRepost', this.numberRepost + 1);
      });

      return await modal.present();
    },
    async openShareMyStoryModal(sliderImage) {
      const modal = await modalController.create({
        component: ShareMyStoryModal,
        cssClass: "modal-custom-class",
        componentProps: {
          title: this.$t("modalhead.sharestory"),
          image: sliderImage,
        },
      });
      modal.onDidDismiss().then(() => {
        this.completedPost();
        this.presentToast('bottom', 'Post Shared!');
        this.$emit('update:numberRepost', this.numberRepost + 1);
      });

      return await modal.present();
    },
    async likeStart($event, story, index) {
      //console.log("like start");
      //console.log($event + " " + story + " " + index);
      if (this.$store.state.auth.token != "") {
        this.popupEvent = setTimeout(() => {
          this.openLikePopover($event, story, index);
        }, 800);
      }
    },
    async likeStop() {
      //console.log('like stop');
      //console.log($event+' '+story+' '+index);
      clearTimeout(this.popupEvent);
    },
    async likeItem() {
      //console.log("liked item");
      if (this.$store.state.auth.token != "") {
        if (this.likeit == 1) {
          //console.log('toggle');
          this.toggleLike();
        } else {
          let role = "Love It";
          //console.log(this.pik_id);
          let response = await this.$store.dispatch("likes/likeit", {
            type: role,
            imageid: this.pik_id,
          });
          if (response) {
            if (response["error"] != null) {
              console.log(response["error"], "error liking");
            } else {
              //console.log(this.likes + 1, 'completed post');
              this.completedPost();
              this.$emit('update:likes', this.likes + 1);
              this.$emit('update:likeittype', role);
              this.$emit('update:likeit', 1);
            }
          } else {
            console.log("unknown error");
          }

        }
      } else {
        this.presentLoginAlertConfirm();
      }
    },
    async openLikePopover(ev, story) {
      if (this.$store.state.auth.token != "") {
        if (this.likeittype == 1) {
          console.log("you already like it");
        } else {
          const popover = await popoverController.create({
            component: LikePopover,
            cssClass: "like-popover-class",
            event: ev,
            alignment: 'start',
            componentProps: {
              name: "",
              type: "likes-image",
              data: story,
              translucent: false,
              
            },
          });

          //setTimeout(async () => {
          await popover.present();
          //}, 750);

          const { role } = await popover.onDidDismiss();
          //console.log(role,"role");
          if (role != "" && role != "backdrop") {
            let response = await this.$store.dispatch("likes/likeit", {
              type: role,
              imageid: this.pik_id,
            });
            if (response) {
              if (response["error"] != null) {
                console.log("error liking");
              } else {
                this.completedPost();
                this.$emit('update:likes', this.likes + 1);
                this.$emit('update:likeittype', role);
                this.$emit('update:likeit', 1);
              }
            } else {
              console.log("unknown error");
            }
            //console.log('clicked the like: ' + role);
          }
          //console.log('onDidDismiss resolved with role', role);
        }

      } else {
        this.presentLoginAlertConfirm();
      }
    },
    async toggleLike() {
      let response = await this.$store.dispatch("likes/toggle", {
        type: '',
        imageid: this.pik_id,
      });
      if (response) {
        if (response['error'] != null) {
          this.error = response['error'];
        } else {
          this.completedPost();
          this.$emit('update:likes', this.likes - 1);
          this.$emit('update:likeittype', '');
          this.$emit('update:likeit', 0);

        }
      } else {
        this.error = "Unkown error";
      }
      //console.log('clicked the toggle like');
    },
    displayIcon(item) {
      var icon = heartOutline;
      if (item != null) {
        if (item.search("Great Shot") != -1) {
          icon = videocam;
        }
      }
      return icon;
    },
    displayCustomIcon(item) {
      var iconSrc = "";
      if (item != null) {
        if (item.search("Cool") != -1) {
          iconSrc = "/assets/cool.svg";
        } else if (item.search("Wow") != -1 || item.search("Dislike") != -1) {
          iconSrc = "/assets/wow.svg";
        } else if (item.search("Cute") != -1) {
          iconSrc = "/assets/cute.svg";
        } else if (item.search("LOL") != -1) {
          iconSrc = "/assets/laughing_2.svg";
        }
      }
      return iconSrc;
    },
    displayStyle(item) {
      var iconColor = "font-size: 18px; color:rgba(140,140,140,1.0);";
      if (item != null && item != "") {
        if (item.search("Great Shot") == -1) {
          iconColor = "font-size: 18px; color:red;";
        }
      }
      return iconColor;
    },

    getImageIndex(imageId) {
      var itemIndex = 0;
      //if (storyImageIndex == null) {
      var currentImages = this.story.allimages;
      for (var i = 0; i < currentImages.length; i++) {
        if (currentImages[i].id == imageId) {
          itemIndex = parseInt(currentImages[i].current_index);
        }
      }
      /* } else {
        itemIndex = parseInt(storyImageIndex);
      }*/
      return itemIndex + 1;
    },
    completedPost() {
      var streamName = '';
      var userid = '';
      var imageid = null;
      if (this.slider == 1) {
        streamName = 'story';
        imageid = this.pik_id;
        this.$store.dispatch("pikstream/getStream", {
          streamName: streamName,
          filter: null,
          imageid: imageid,
          storyid: null,
          total_list: 7,
          last_id: 0,
          userid: userid
        });
      }/*else{
        if(this.$route.name=="myprofile"){
          streamName = 'myprofile';
        }else if(this.$route.name=="profile"){
          streamName = 'profile';
          userid = this.$route.params.id;
        }
      }*/
    },
    async presentLoading() {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: this.$t('loadmessage.loading'),
        });
      await this.loadingIndicator.present();
    },
    async openStoryPostsModal() {
      //console.log(story);
      // NOTE: use the pik_id and get the full image object
      if (this.checkPremium()) {
        if(this.$store.state.pikstream.storyResponseData[this.pik_id]==null){
          this.presentLoading();
          await this.$store.dispatch("pikstream/getStream", {
            streamName: 'story',
            filter: null,
            imageid: this.pik_id,
            storyid: null,
            total_list: 1,
            current_page: 0,
            userid: null
          });
          this.loadingIndicator.dismiss();
        }
        
        const modal = await modalController.create({
          component: StoryPostsModal,
          //cssClass: "shareother-custom-class",
          componentProps: {
            story: this.$store.state.pikstream.storyResponseData[this.pik_id],
          },
        });
        return await modal.present();
      }
    },
    getHostName(url) {
      var match = '';
      if (url != '' && url != undefined) {
        match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      }
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      } else {
        return null;
      }
    },
    async openLink(link_url) {
      if (link_url != '') {
        if (isPlatform('hybrid') || isPlatform('electron')) {
          await Browser.open({ url: link_url, presentationStyle: 'popover' });
        }else{
          window.open(link_url, '_blank');
        }
      }
    },
    checkPremium() {
      let canView = true;
      if (this.story.isPremium == 'yes' && this.story.canViewPremium == 'no') {
        canView = false;
      }
      return canView;
    },
    async presentToast(position, message) {
      const toast = await toastController.create({
        message: message,
        duration: 1500,
        position: position
      });

      await toast.present();
    },
    async presentLoginAlertConfirm() {
      const alert = await alertController.create({
        cssClass: "my-custom-class",
        header: this.$t('alerthead.login'),
        message: this.$t('alertmessage.login', { app: getEnv("APP_NAME") }),
        buttons: [
          {
            text: this.$t('header.signup'),
            cssClass: 'primary',
            handler: () => {
              this.signup();
            },
          },
          {
            text: this.$t('header.login'),
            handler: () => {
              this.login();
            },
          },
          {
            text: this.$t('buttons.cancel'),
            role: 'cancel',
            cssClass: 'secondary',
          },

        ],
      });
      return alert.present();
    },
    signup() {
      if(getEnv('APP_NAME') == 'VoclNEW'){
        this.fsbnConnect('signup');
      }else{
        this.presentSignup('signup');
      }
    },
    login() {
      if(getEnv('APP_NAME') == 'VoclNEW'){
        this.fsbnConnect('login');
      }else{
        this.presentSignup('login');
      }
      
    },
    async fsbnConnect(type) {
      let redirect = 'https://' + window.location.hostname + '/idauth';
      if (isPlatform('hybrid') || isPlatform('electron')) {
        redirect = 'https://' + getEnv('SHARE_HOSTNAME') + '/idauth';
      }
      const client_id = 'ceb0f61a-976b-4b29-a59f-55ec3f600d6f';
      let url_add = '';
      if(type=="signup") url_add = '&goto=signup';
      if(getEnv('REQUEST_URL')=='https://api.vocl.com/'){
        this.openLink('https://signin.frankspeech.com/OAuth/Start?redirect_uri='+redirect+'&client_id='+client_id+'&response_type=code&state='+type+url_add);
      }else{
        this.openLink('https://test-signin.frankspeech.com/OAuth/Start?redirect_uri='+redirect+'&client_id='+client_id+'&response_type=code&state='+type+url_add);
      }
    },
    async presentSignup(type, button) {
      let title = this.$t('header.login');
      if (type == "signup") {
        title = this.$t('header.signup');
      }
      const modal = await modalController
        .create({
          component: SignupModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: title,
            loginType: type,
            source: 'link'
          }
        })
      await modal.present();

      const { role } = await modal.onDidDismiss();
      if (role == 'loggedin') {
        if (button == 'buy') {
          this.openBuyModal();
        }
      }
    },
    checkGroupStatus(){
      let canChat = true;
      if(this.story.groupInfo!=null && this.story.groupInfo.id!=null){
        canChat = false;
        if(this.story.groupInfo.isMember || this.story.groupInfo.isAdmin){
          canChat = true;
        }
      }
      return canChat;
    },
    commentBox(){
      let showbox = false;
      if(this.$store.state.auth.token == ''){
        return showbox;
      }else if(this.story.groupInfo.id!=undefined && this.checkGroupStatus() && this.totalcomments>0){
        showbox = true;
      }else if(this.story.groupInfo.id!=undefined && this.checkGroupStatus() && (this.$route.name == 'story' || this.$route.name == 'storyview')){
        showbox = true;
      }else if(this.story.groupInfo.id==undefined && (this.$route.name == 'story' || this.$route.name == 'storyview')){
        showbox = true;
      }
      return showbox;
    },
    imgUrlAlt(event) {
      event.target.src = "/assets/link.png";
    }
  }
});
</script>
<style>
@media (max-width: 599px) {
  .lg-screen {
    display: none;
  }
  .like-popover-class {
    --width:auto;
  }
}

.action-button {
  --box-shadow: 0px;
  --padding-top: 5px;
  --padding-bottom: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
  /* height:20px; */
}

.like-popover-class {
    --width:400px;
}
</style>